import WireStructure from '@/components/wire/wire-animation';
import Services from '@/components/sections/services';
import Accordian from '@/components/sections/accordian';
import BlogsSlider from '@/components/sections/blogsSlider';
import CTASection from '@/components/sections/ctaSection';
import { Service } from '@/app/shared/type';

import Link from "next/link";
interface LandingProps {
  services: Service[];
}
export default function Home({ services }: LandingProps) {
  return (
    <main>
      <WireStructure />
      <div className="container-full bg-[#0a0a23] services-sec">
        <div className='nimbus-container'>
          <Services services={services} />
        </div>
      </div>

      {/* <div className="container-full services-sec">
        <div className='nimbus-container'>
          <h2 className="global-heading text-[#fff] text-center mb-[10px]">Industries We Serve</h2>
          <p className="text-[#fff] text-center mb-[3rem]">Unlock your true potential and discover a world of opportunities that align with your skills, interests, and aspirations</p>

          <div className="industry-grid">
            <div className="box">
              <div className="left-sec">
                01 <strong>BFSI</strong>
              </div>
              <div className="right-sec">
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
                </p>
              </div>
            </div>
            <div className="box">
              <div className="left-sec">
                02 <strong>Education & Logistics</strong>
              </div>
              <div className="right-sec">
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
                </p>
              </div>
            </div>
            <div className="box">
              <div className="left-sec">
                03 <strong>Travel</strong>
              </div>
              <div className="right-sec">
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
                </p>
              </div>
            </div>
            <div className="box">
              <div className="left-sec">
                04 <strong>Finance</strong>
              </div>
              <div className="right-sec">
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
                </p>
              </div>
            </div>
          </div>

          <Link href={"/services"} className="global-btn">
            Know All 
            <FontAwesomeIcon icon={faArrowRight} />
        </Link>

        </div>
      </div> */}

      {/* <div className="container-full CaseStudy-sec">
        <div className='nimbus-container'>
          <CaseStudiesSlider />
        </div>
      </div> */}

      {/* <div className="container-full Testimonial-sec">
        <div className='nimbus-container'>
          <h2 className="text-center font-bold text-white">Testimonials</h2>
          <TestimonialSlider />
          <Link href={"/services"} className="global-btn">
            View All 
            <FontAwesomeIcon icon={faArrowRight} />
        </Link>
        </div>
      </div> */}

      <div className="container-full Blogs-sec">
        <div className='nimbus-container'>
          <h2 className="text-center font-bold">Blogs</h2>
          <BlogsSlider />
          {/* <Link href={"/services"} className="global-btn">
            View All 
            <FontAwesomeIcon icon={faArrowRight} />
          </Link> */}
        </div>
      </div>

      <div>
        <CTASection />
      </div>

      <div className="container-full FAQ-sec">
        <div className='nimbus-container'>
          <h2 className="text-center font-bold">Everything You Need to Know!</h2>
          <p className='text-center sub-head'>Unlock your true potential and discover a world of opportunities that align with your skills, interests, and aspirations</p>
          <Accordian />
        </div>
      </div>



    </main>
  );
}
